import { useOnboardingStore } from '../../store/useOnboardingStore';
import logo from "../../assets/images/logo_2.png";
import diamond from "../../assets/images/love_diamond.png";
import { Link } from 'react-router-dom';
const StartBoard = () => {
  const { nextStep } = useOnboardingStore();
  const handleStart = (e: React.MouseEvent) => {           
    e.preventDefault(); // href="#" ka page jump rokta hai
    nextStep();          // 2 → 3 (Step2 component)
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="" className="img-fluid" />
          </Link>
        </div>
      </nav>

      <section className="bg-light onboarding_main_wraper py-60 d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-10 offset-lg-2 offset-md-1">
              <div className="onboarding_step_two text-center">
                <img src={diamond} alt="" className="img-fluid mb-4" />
                <h2>You're in! Welcome aboard!</h2>
                <p className="my-md-4 my-3">
                  Let's quickly set up your profile to showcase what makes you unique!
                </p>
                {/* FIX: e.preventDefault() + nextStep() — href="#" se page jump nahi hoga */}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleStart}   
                >
                  Let's Get Started!
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StartBoard;
